// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__vm32Q","header":"About_header__ejYEm","green":"About_green__3LA00","subhead":"About_subhead__38P9E","techs":"About_techs__1txYe"};